<template>
	<div class="activity-panel-layout">
		<h1 class="title"><slot name="title"></slot></h1>
		<section class="feed">
			<slot name="feed"></slot>
		</section>
	</div>
</template>

<script>
export default {
	name: "ActivityPanelLayout",
};
</script>

<style lang="scss" scoped>
$activityPanelLayoutTitleColor: $color1-500;

.activity-panel-layout {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 1rem;
}

.title {
	@include font-and-line-for(-1);
	font-weight: 450;
	color: $activityPanelLayoutTitleColor;
	text-align: left;
}

.feed {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
}
</style>
